module.exports = __webpack_public_path__ + "img/footer-icon5.8f5b0d02.png";